import { MutableRefObject, useEffect } from 'react'

export type UseScrollFetch = {
  threshold?: number
  hasNextPage: boolean
  fetchNextPage: () => void
  isFetchingNextPage: boolean
  scrollRef: MutableRefObject<HTMLDivElement | null>
}

export const useScrollFetch = ({
  scrollRef,
  hasNextPage,
  fetchNextPage,
  threshold = 50,
  isFetchingNextPage,
}: UseScrollFetch) => {
  useEffect(() => {
    const currentRef = scrollRef.current

    if (!currentRef) {
      return
    }

    const handleScroll = () => {
      if (!currentRef) {
        return
      }

      const { scrollTop } = currentRef

      if (scrollTop <= threshold && !isFetchingNextPage && hasNextPage) {
        fetchNextPage()
      }
    }

    currentRef.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      currentRef.removeEventListener('scroll', handleScroll)
    }
  }, [scrollRef, isFetchingNextPage, hasNextPage, fetchNextPage, threshold])
}
